import { Dispatch } from 'redux';

import { automationsApi } from 'src/services/api/automationsApi';
import { AutomationRun } from 'src/types/automations';

import { Events } from '../constants/webSocketConsts/events';

import { updateListCache } from './updateListCache';

// A run can start before this client subscribed to its list, so a MODIFY
// for an unseen run has to add it rather than be dropped.
const listCacheOptions = { insertMissingOnModify: true };

export function handleAutomationRunsUpdate(
  event: Events,
  items: AutomationRun[],
  dispatch: Dispatch<any>,
) {
  dispatch(
    automationsApi.util.updateQueryData(
      'getAllWorkspaceAutomationRuns',
      undefined,
      (draft?: AutomationRun[]) => {
        updateListCache(event, items, draft, listCacheOptions);
      },
    ),
  );
  dispatch(
    automationsApi.util.updateQueryData(
      'getAutomationRuns',
      { id: items.at(0)?.automationId || '' },
      (draft?: AutomationRun[]) => {
        updateListCache(event, items, draft, listCacheOptions);
      },
    ),
  );
}
